import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Params} from '@angular/router';
import {QueryParams} from '../../types/QueryParams';
import {ToolsService} from '../tools.service';
import {isPlatformBrowser} from '@angular/common';
import {RoutesEnums} from '../../enums/RoutesEnums';

@Injectable({
  providedIn: 'root',
})
export class SearchReloadService {
  private queryParams: Params;
  private params: Params;

  constructor(
    private tools: ToolsService,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {}

  public reload(routerLink: string[], queryParams: QueryParams) {
    if (isPlatformBrowser(this.platformId)) {
      if (this.isReloadToTheSameUrl(routerLink, queryParams)) {
        window.location.reload();
      }
    }
  }

  public updateParams(params: Params, queryParams: Params): void {
    this.params = params;
    this.queryParams = queryParams;
  }

  private isReloadToTheSameUrl(routerLink: string[], queryParams: QueryParams): boolean {
    const currentRouterLink: string[] = ['/', RoutesEnums.SEARCH];
    if (!this.tools.isNil(this.params)) {
      Object.keys(this.params).forEach((key) => {
        currentRouterLink.push(this.params[key]);
      });
    }

    return this.tools.isEqual(routerLink, currentRouterLink) && this.tools.isEqual(queryParams, this.queryParams);
  }
}
